module.exports = __webpack_public_path__ + "img/final-img.3f672bb4.jpg";